export enum UpdateDebouncerEventType {
  WillFlush = 'WillFlush',
  DidFlush = 'DidFlush',
}
